export default __webpack_public_path__ + "static/media/ransomewareRealcase-mobile.0ee89770.png";